import axios from "./axios";

export default class MsiService {
    static getMsiProfile(code) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual', { code });
    }
    static signUp(payload) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/registration', payload);
    }
    static sendRecoveryPasswordOtp(login) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/start', { login });
    }
    static verifyRecoveryPasswordOtp(payload) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/verify', payload);
    }
    static setNewPassword(payload) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/finish', payload);
    }
    static changePassword(payload) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/change-password', payload);
    }
}